import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export const FaqAccordion = ({ items }) => {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <div className="space-y-3" data-testid="faq-accordion">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div
            key={item.id}
            className="bg-card border border-brand-border rounded-lg overflow-hidden"
            data-testid={`faq-item-${item.id}`}
          >
            <button
              type="button"
              onClick={() => toggle(item.id)}
              aria-expanded={isOpen}
              aria-controls={`faq-answer-${item.id}`}
              id={`faq-question-${item.id}`}
              data-testid={`faq-question-${item.id}`}
              className="w-full flex items-center justify-between gap-4 text-left px-4 sm:px-5 py-4 font-display font-bold text-brand-dark text-sm sm:text-base uppercase tracking-tight hover:bg-brand-ivory/60 transition-colors"
            >
              <span>{item.question}</span>
              <ChevronDown
                className={`w-5 h-5 text-brand-red shrink-0 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
              />
            </button>
            <div
              id={`faq-answer-${item.id}`}
              role="region"
              aria-labelledby={`faq-question-${item.id}`}
              data-testid={`faq-answer-${item.id}`}
              className={`grid transition-all duration-200 ease-in-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
            >
              <div className="overflow-hidden">
                <p className="px-4 sm:px-5 pb-4 font-sans text-brand-dark/80 text-sm sm:text-base leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
